import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React from 'react'
import { FaEdit, FaTimes } from 'react-icons/fa';

const SchedulesTable = ({
    schedules,
    onDelete,
    onEdit
}) => {
    const columns = React.useMemo(
        () => [
            {
                header: 'Site',
                accessorKey: 'site.name',
            },
            {
                header: 'Officer',
                accessorKey: 'officer.name',
            },
            {
                header: 'Shift',
                accessorKey: 'shift.name',
            },
            {
                header: 'Start Date',
                accessorKey: 'start_date',
            },
            {
                header: 'End Date',
                accessorKey: 'end_date',
            },
            {
                header: 'Created By',
                accessorKey: 'supervisor.name',
            },
            {
                header: 'Date Created',
                accessorKey: 'created_at',
            },
            {
                header: 'Date Updated',
                accessorKey: 'updated_at',
            },
            {
                header: 'Actions',
                id: 'actions',
                cell: ({row}) => (
                    <>
                        <FaTimes 
                            className='fa-times'
                            data-toggle='tooltip'
                            data-placement='bottom'
                            onClick={() => onDelete(row.original.id)}
                            title='Delete'
                        />
                        <FaEdit
                            className='fa-edit'
                            data-toggle='tooltip'
                            data-placement='bottom'
                            onClick={() => onEdit(row.original.id)}
                            title='Edit'
                        />
                    </>
                )
            }
        ],
        [onDelete, onEdit]
    );

    const table = useReactTable({
        data: schedules,
        columns,
        getCoreRowModel: getCoreRowModel()
    });

    if (schedules.length === 0){
        return <div className="text-center">No schedules found</div>
    }
  return (
    <table className='table table-striped'>
        <thead>
            {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                        <th key={header.id}>{header.column.columnDef.header}</th>
                    ))}
                </tr>
            ))}
        </thead>
        <tbody>
            {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                        <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                    ))}
                </tr>
            ))}
        </tbody>
    </table>
  )
}

export default SchedulesTable